<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from 'vue-router'
import DJIcon from '~/components/ui/icon/Icon.vue'
import { IconUserCircleCheckDuotone, IconMapTrifoldDuotone, IconSmileyDuotone, IconShieldCheckDuotone } from '~/components/ui/icon/icons'

const route = useRoute()
const isBookableTrip = computed(() => route.name === 'trip-plan-bookable')
const itemsReason = computed(() => [
  {
    icon: IconUserCircleCheckDuotone,
    title: 'Private, Personalised Travel',
    desc: isBookableTrip.value
      ? 'This locally-inspired trip plan is curated exclusively for you and your party.'
      : "No generic group tours. Just the activities you love, and nothing you don't.",
  },
  {
    icon: IconMapTrifoldDuotone,
    title: isBookableTrip.value ? 'Value for Money' : 'Insider Local Knowledge',
    desc: isBookableTrip.value
      ? 'Experience extraordinary travel for your budget by utilising our local connections and insider expertise.'
      : 'Access insider tips, hidden gems and authentic experiences known only to locals.',
  },
  {
    icon: IconSmileyDuotone,
    title: isBookableTrip.value ? 'Flexible Payment' : 'End-to-end Service',
    desc: isBookableTrip.value
      ? 'Use our secure booking platform to pay a deposit now and the balance 60 days before the trip. We are an accredited Australian company with comprehensive financial guarantees in place.'
      : 'From the initial planning to full support while travelling, Designer Journeys provides seamless service every step of the way.',
  },
  {
    icon: IconShieldCheckDuotone,
    title: 'Travel With Confidence',
    desc: isBookableTrip.value
      ? 'From our international team to your Local Designer on the ground, we offer 24/7 support so you can travel with complete peace of mind.'
      : 'Feel assured travelling with an accredited Australian company with comprehensive financial guarantees and a local emergency system.',
  },
])
const title = computed(() => (isBookableTrip.value ? 'Bespoke Adventures, Distinctly Yours' : 'Customise this trip for a perfect match'))
</script>

<template>
  <section class="py-24">
    <h2 class="mb-16 heading-4-bd">{{ title }}</h2>
    <div v-for="(item, index) in itemsReason" :key="index" class="flex mb-16">
      <DJIcon :size="20" color="#3E9377" class="mt-4">
        <component :is="item.icon" />
      </DJIcon>
      <div class="flex flex-column ml-12">
        <span class="text-md-sb gray-950">{{ item.title }}</span>
        <span class="text-sm-rg gray-700">{{ item.desc }}</span>
      </div>
    </div>
    <span class="text-md-sb gray-950">More than 1900 travellers have booked with us. Join them to make your next trip full of lifelong memories.</span>
  </section>
</template>

<style lang="scss" scoped></style>
